// Fontsource imports for Google Fonts
import "@fontsource/playfair-display/400.css";
import "@fontsource/playfair-display/700.css";
import "@fontsource/playfair-display/400-italic.css";
import "@fontsource/playfair-display/700-italic.css";
import "@fontsource/source-serif-4/400.css";
import "@fontsource/source-serif-4/600.css";
import "@fontsource/source-serif-4/700.css";
import "@fontsource/inter/300.css";
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";
import "@fontsource/lato/400.css";
import "@fontsource/lato/700.css";
import "@fontsource/tenor-sans/400.css";
// Flag-controlled redirects for pre-registration stage
// Set env var GATSBY_REDIRECT_TO_PREREG=true to enable

const isPreRegEnabled = process.env.GATSBY_REDIRECT_TO_PREREG === 'true';
const normalizePath = (p) => (p ? p.replace(/\/$/, '') : '');
const allowedPaths = ['/pre-register', '/contact'];

export const onClientEntry = () => {
	if (!isPreRegEnabled) return;
	try {
		const current = normalizePath(window.location.pathname) || '/';
		if (allowedPaths.includes(current)) return;
		const already = sessionStorage.getItem('preregRedirectDone');
		if (already === '1') return;
		if (current === '/' || current === '') {
			sessionStorage.setItem('preregRedirectDone', '1');
			window.location.replace('/pre-register');
		}
	} catch (_) {}
};

export const onRouteUpdate = ({ location }) => {
	if (!isPreRegEnabled) return;
	const current = normalizePath(location && location.pathname) || '/';
	if (allowedPaths.includes(current)) return;
	const already = sessionStorage.getItem('preregRedirectDone');
	if (already === '1') return;
	if (current === '/' || current === '') {
		sessionStorage.setItem('preregRedirectDone', '1');
		window.location.replace('/pre-register');
	}
};

// Prevent scroll-to-top on desktop navigation, allow on mobile.
// Gatsby scrolls normally when this hook returns true. Returning false keeps
// the current viewport position across route changes.
export const shouldUpdateScroll = () => {
	if (typeof window === 'undefined') return false;
	
	// On desktop (viewport >= 769px), maintain scroll position
	if (window.innerWidth >= 769) {
		return false;
	}
	
	// On mobile, scroll to top (Gatsby default behavior)
	return [0, 0];
};
